import { createApi } from '@reduxjs/toolkit/query/react';
import { authBaseQuery } from '../utils/authBaseQuery';

const baseUrl =
  process.env.NEXT_PUBLIC_USE_SECURITY === 'true'
    ? process.env.NEXT_PUBLIC_API_SECURITY
    : process.env.NEXT_PUBLIC_API_EVENT;

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: authBaseQuery({
    baseUrl: `${baseUrl}/checkout-users-command/api/v1`,
  }),
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (credentials) => ({
        url: 'signIn',
        method: 'POST',
        body: credentials,
      }),
    }),
    signUp: builder.mutation({
      query: ({ name, phone, email, password }) => ({
        url: 'signUp',
        method: 'POST',
        body: {
          fist_name: name,
          phone_numer: phone,
          email,
          hash_password: password,
        },
      }),
    }),
    signUpGuest: builder.mutation({
      query: ({
        name,
        phone,
        email,
        event_id,
        media,
        bookingOrder,
        bookingId,
      }) => ({
        url: 'signUp',
        method: 'POST',
        body: {
          fist_name: name,
          phone_numer: phone,
          email,
          event_id,
          guest: true,
          hash_password: '@TestBoletia2029',
          media,
          booking_order: bookingOrder,
          booking_id: bookingId,
        },
      }),
    }),
    verifyCode: builder.mutation({
      query: ({ code, email, bookingOrder, bookingId }) => ({
        url: 'users/verification',
        method: 'PUT',
        body: {
          email,
          code,
          guest: true,
          booking_order: bookingOrder,
          booking_id: bookingId,
        },
      }),
    }),
    resendCode: builder.mutation({
      query: ({ email, media }) => ({
        url: 'users/resend-verification-code',
        method: 'PUT',
        body: {
          email,
          guest: true,
          media,
        },
      }),
    }),
  }),
});

export const {
  useSignInMutation,
  useSignUpMutation,
  useSignUpGuestMutation,
  useVerifyCodeMutation,
  useResendCodeMutation,
} = authApi;
